// extracted by mini-css-extract-plugin
export var dropdownIcon = "_iz-6";
export var imgContainer = "_iz-3";
export var menuIcon = "_iz-5";
export var pillWrapper = "_iz-2";
export var pillsContainer = "_iz-1";
export var subscriptionCard = "_iz-0";
export var subscriptionLogo = "_iz-4";